import Image, { getImageProps } from 'next/image';

interface ResponsiveShopImageProps {
  desktopSrc: string;
  mobileSrc: string;
  alt: string;
  className?: string;
  priority?: boolean;
  quality?: number;
  mobileSizes?: string;
  desktopSizes?: string;
}

export default function ResponsiveShopImage({
  desktopSrc,
  mobileSrc,
  alt,
  className = '',
  priority = false,
  quality = 75,
  mobileSizes = '100vw',
  desktopSizes = '100vw',
}: ResponsiveShopImageProps) {
  const mobile = mobileSrc || desktopSrc;
  const desktop = desktopSrc || mobileSrc;

  if (!mobile && !desktop) return null;

  if (mobile === desktop) {
    return (
      <Image
        src={mobile}
        alt={alt}
        fill
        priority={priority}
        quality={quality}
        sizes={desktopSizes}
        className={`object-cover ${className}`}
      />
    );
  }

  const {
    props: { srcSet: desktopSrcSet },
  } = getImageProps({
    alt,
    src: desktop,
    fill: true,
    sizes: desktopSizes,
    priority,
    quality,
  });
  const {
    props: { srcSet: mobileSrcSet, ...mobileProps },
  } = getImageProps({
    alt,
    src: mobile,
    fill: true,
    sizes: mobileSizes,
    priority,
    quality,
  });

  return (
    <picture className="absolute inset-0 block h-full w-full">
      <source
        media="(min-width: 768px)"
        srcSet={desktopSrcSet}
        sizes={desktopSizes}
      />
      {/* eslint-disable-next-line jsx-a11y/alt-text -- alt comes from getImageProps */}
      <img
        {...mobileProps}
        srcSet={mobileSrcSet}
        sizes={mobileSizes}
        className={`absolute inset-0 h-full w-full object-cover ${className}`}
      />
    </picture>
  );
}
